import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  FiHome,
  FiDollarSign,
  FiFolder,
  FiUsers,
  FiLink,
  FiShield,
  FiChevronLeft,
  FiActivity
} from 'react-icons/fi';
import { toggleSidebar } from '../../redux/slices/uiSlice';
import './Sidebar.css';

const Sidebar = () => {
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);

  const isAdmin = user?.role === 'admin';

  return (
    <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <span className="logo-icon">H</span>
          {sidebarOpen && <span className="logo-text">Herald Processing</span>}
        </div>
        <button className="sidebar-toggle" onClick={() => dispatch(toggleSidebar())}>
          <FiChevronLeft />
        </button>
      </div>

      <nav className="sidebar-nav">
        {sidebarOpen && <div className="sidebar-section-title">Menu</div>}

        {/* Dashboard */}
        <NavLink
          to="/dashboard"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="Dashboard"
        >
          <span className="nav-icon"><FiHome /></span>
          {sidebarOpen && <span className="nav-label">Dashboard</span>}
        </NavLink>

        {/* Projects */}
        <NavLink
          to="/projects"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="Projects"
        >
          <span className="nav-icon"><FiFolder /></span>
          {sidebarOpen && <span className="nav-label">Projects</span>}
        </NavLink>

        {/* Transactions */}
        <NavLink
          to="/transactions"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="Transactions"
        >
          <span className="nav-icon"><FiDollarSign /></span>
          {sidebarOpen && <span className="nav-label">Transactions</span>}
        </NavLink>

        {sidebarOpen && <div className="sidebar-section-title">Settings</div>}

        {/* IP Whitelist */}
        <NavLink
          to="/ip-whitelist"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="IP Whitelist"
        >
          <span className="nav-icon"><FiShield /></span>
          {sidebarOpen && <span className="nav-label">IP Whitelist</span>}
        </NavLink>

        {/* Webhooks */}
        <NavLink
          to="/webhooks"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="Webhooks"
        >
          <span className="nav-icon"><FiLink /></span>
          {sidebarOpen && <span className="nav-label">Webhooks</span>}
        </NavLink>

        {/* Webhook Logs */}
        <NavLink
          to="/webhook-logs"
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title="Webhook Logs"
        >
          <span className="nav-icon"><FiActivity /></span>
          {sidebarOpen && <span className="nav-label">Webhook Logs</span>}
        </NavLink>

        {/* Team Members (Admin only) */}
        {isAdmin && (
          <NavLink
            to="/users"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            title="Team Members"
          >
            <span className="nav-icon"><FiUsers /></span>
            {sidebarOpen && <span className="nav-label">Team Members</span>}
          </NavLink>
        )}
      </nav>

      <div className="sidebar-footer">
        {sidebarOpen && (
          <div className="user-info">
            <div className="user-avatar">{user?.name?.charAt(0) || 'U'}</div>
            <div className="user-details">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">{user?.role}</span>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
